import React, { Component } from "react";
import { NavBar, Footer } from "../components/ReusableElements";
import { Document, Page } from "react-pdf/dist/entry.webpack";
import file from "../assets/faq.pdf";
import howto from "../assets/crop_howto.png";

const RenderPages = (props) => {
  var pages = [];

  for (var i = 1; i < props.numPages + 1; i++) {
    pages.push(i);
  }

  const listPage = pages.map((pageNum) => (
    <div key={pageNum}>
      <Page
        width={
          props.wrapperDivSize > 1000
            ? props.wrapperDivSize * 0.8
            : props.wrapperDivSize
        }
        pageNumber={pageNum}
      />
    </div>
  ));

  return <div>{listPage}</div>;
};

export default class About extends Component {
  constructor() {
    super();

    this.state = {
      documentLoaded: false,
      numPages: null,
      pageNumber: 1,
      width: null,
    };
  }

  componentDidMount() {
    this.setDivSize();
    window.addEventListener("resize", this.setDivSize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setDivSize);
  }

  setDivSize = () => {
    this.setState({ width: this.pdfWrapper.getBoundingClientRect().width });
  };

  onDocumentLoad = ({ numPages }) => {
    this.setState({ documentLoaded: true });
    this.setState({ numPages });
  };

  render() {
    return (
      <div className="About">
        <NavBar
          isLoggedIn={this.props.isLoggedIn}
          logout={this.props.toggleIsLoggedIn}
        />
        <div className="about-box">
          <h1 className="terms-title">Frequently Asked Questions</h1>
          <div
            id="pdfWrapper"
            className="document-wrapper"
            ref={(ref) => (this.pdfWrapper = ref)}
          >
            <Document
              file={file}
              onLoadSuccess={this.onDocumentLoad}
              className="faq"
            >
              {this.state.numPages != null ? (
                <RenderPages
                  wrapperDivSize={this.state.width}
                  numPages={this.state.numPages}
                />
              ) : null}

              {this.state.documentLoaded ? (
                <img className="faq-img" src={howto} alt="" />
              ) : null}
              <br></br>
              <br></br>
              <br></br>
              <br></br>
            </Document>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Faq.js